module.exports = __webpack_public_path__ + "img/team_img1.2a3837ad.png";